<template>
  <div>
    <img
      v-if="carga"
      :class="imgClass"
      :src="urlImagen"
      :alt="alt"
      :width="width"
      :height="height"
      @error="onError()"
    />
    <img
      v-else
      :class="imgClass"
      src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/foto-colegio-3.jpg"
      :alt="alt"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script>
export default {
  props: {
    rbd: {
      type: Number,
      required: true
    },
    imagen: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    imgClass: {
      type: String,
      required: false,
      default: ""
    },
    width: {
      type: Number,
      required: false,
      default: 100
    },
    height: {
      type: Number,
      required: false,
      default: 100
    }
  },
  data() {
    return {
      carga: true,
      urlCdn: CDN,
      prefijoImagenes: URL_IMAGENES
    };
  },
  computed: {
    urlImagen() {
      if (this.imagen != "") {
        return (
          this.urlCdn + this.prefijoImagenes + this.rbd + "/" + this.imagen
        );
      } else {
        this.carga = false;
      }
    }
  },
  methods: {
    //funcion ejecutada al existir un error en la carga de imagen
    onError: function() {
      this.carga = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/generales/Imagen.vue